<script lang="ts">
	import { DeviceGroup, DeviceRPi, type Device } from "luxedo-data"
	import DeviceStatusPreviewGroup from "./DeviceStatusPreview_Group.svelte"
	import DeviceStatusPreviewOne from "./DeviceStatusPreview_One.svelte"

	interface Props {
		device: Device
		showControls?: boolean
	}

	let { device, showControls = true }: Props = $props()
</script>

<div class="flex-column device-title-row status-preview">
	{#if device instanceof DeviceGroup}
		<DeviceStatusPreviewGroup {device} {showControls} />
	{:else}
		<DeviceStatusPreviewOne device={device as unknown as DeviceRPi} {showControls} />
	{/if}
</div>

<style>
	.status-preview :global(.projector-status) {
		line-height: 1rem;
		color: var(--color-text);
		display: flex;
		align-items: center;
	}

	.status-preview {
		overflow: hidden;
		padding-bottom: 0.2rem;
	}

	.status-preview :global(.projector-status-indicator) {
		background-color: var(--color-status);
		margin-right: 0.5rem;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 100%;
	}

	@keyframes flashing {
		0% {
			background-color: var(--color-status);
		}

		50% {
			background-color: var(--color-text);
		}

		100% {
			background-color: var(--color-status);
		}
	}

	.status-preview :global(.projector-status-indicator.isChanging) {
		animation-name: flashing;
		animation-duration: 2s;
		animation-iteration-count: infinite;
	}

	.status-preview :global(h1.device-name) {
		font-size: 3rem;
		color: var(--color-text-light);
		margin: 0;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	:global(.isMobile) .status-preview :global(h1.device-name) {
		font-size: var(--h1);
	}

	.status-preview :global(.control-button) {
		padding: 0 0.25rem;
		margin-top: 0.2rem;
	}

	.status-preview :global(.device-control) {
		height: 1.25rem;
		margin-left: 0.5rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
